export default __webpack_public_path__ + "static/media/search_contrata.9af3000d.png";